import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { NoSymbolIcon } from '@heroicons/react/16/solid';
import { AmenitySuspensionReturn } from '../clients/rust-api-client';
import { reservationOperationsService } from '../clients/ApiClients';
import { formatDayLabel } from './reservationMeta';
import { suspensionScope } from './phaseThreeMeta';

/**
 * On a home's page: a line for each booking suspension in force (#642,
 * phase 3), linking to the association's suspensions. Nothing when there
 * is none — or when the list cannot be read, since this is a notice, not
 * the record.
 */
export const HomeSuspensionBadge: React.FC<{ hoaId: string; homeId: string }> = ({ hoaId, homeId }) => {
  const [active, setActive] = useState<AmenitySuspensionReturn[]>([]);

  useEffect(() => {
    let live = true;
    reservationOperationsService
      .listAmenitySuspensions({ hoaId, homeId, active: true })
      .then((r) => live && setActive(r.data.suspensions))
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [hoaId, homeId]);

  if (active.length === 0) return null;
  const thisYear = new Date().getFullYear();
  return (
    <div className="space-y-1">
      {active.map((s) => (
        <p
          key={s.id}
          className="inline-flex flex-wrap items-center gap-1.5 rounded-md bg-warning/10 px-2.5 py-1 text-[13px] text-fg-secondary"
        >
          <NoSymbolIcon className="h-3.5 w-3.5 text-warning" aria-hidden />
          Suspended from booking {suspensionScope(s) === 'All amenities' ? 'every amenity' : suspensionScope(s)} until{' '}
          {formatDayLabel(s.ends_on, thisYear)}
          <Link to={`/hoa/${hoaId}/reservations/suspensions`} className="text-accent-fg hover:underline">
            Details
          </Link>
        </p>
      ))}
    </div>
  );
};

export default HomeSuspensionBadge;
